export default __webpack_public_path__ + "3f827b6f09f7862bd9b26f4b2400aab4.svg";